import React, { useEffect, useState } from 'react';
import { VersaoAppService } from '../../../services/versaoAppService';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { FaRegCheckCircle } from 'react-icons/fa';
import {
  ColumnGap,
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  MainContent,
  Row,
  SubTitle,
  Text,
  WrapperLegend,
} from '../../../../../components/StyledComponents';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { useHistory } from 'react-router-dom';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import axios from 'axios';
import moment from 'moment';
import { removeEmpty } from '../../../../../utils/utils';

export const GerenciarVersaoApp = () => {
  const history = useHistory();
  const { showModal } = React.useContext(BaSeDialogContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({});
  const [statusFilter, setStatusFilter] = useState(null);
  const [filterOptions, setFilterOptions] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState(null);
  const [pendants, setPendants] = useState(0);
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: 'id',
    direction: 'DESC',
  });

  const getPendants = async (source) => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    if (statusFilter) {
      bodyParams.status = statusFilter;
    }
    const response = await VersaoAppService.getPedants(bodyParams, source);
    setPendants(response);
  };

  const getDataExcel = async () => {
    const source = axios.CancelToken.source();
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    if (statusFilter) {
      bodyParams.status = statusFilter;
    }
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };
    const response = await VersaoAppService.findAll(
      pageFilter,
      bodyParams,
      source
    );
    return response?.content?.map((r) => ({
      COD: r.id,
      VERSAO: r.versao,
      PLATAFORMA: r.plataforma,
      STATUS: r.status,
      DATA: r?.dataCriacao ? moment(r?.dataCriacao).format('DD/MM/YYYY') : '',
    }));
  };

  const getData = async (source) => {
    try {
      const bodyParams = removeEmpty({
        ...filters,
        oqueVoceProcura: inputSearchValue,
      });
      if (statusFilter) {
        bodyParams.status = statusFilter;
      }
      const response = await VersaoAppService.findAll(
        paginationFilters,
        bodyParams,
        source
      );
      setIsLoading(false);
      setData(response);
      getPendants(source);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Requisição cancelada', error.message);
      } else {
        console.log(error.message);
      }
    }
  };

  const getFilterOptionsData = async () => {
    setFilterOptions({});
    const response = await VersaoAppService.getFilterOptions();
    setFilterOptions(response);
  };

  const onConfirmChangeStatus = async (version) => {
    const status = version.status === 'APROVADO' ? 'DESAPROVADO' : 'APROVADO';
    return await VersaoAppService.changeStatus(version.id, status);
  };

  const onClickClearFilters = async () => {
    setIsLoading(true);
    setData([]);
    setStatusFilter(null);
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: 'id',
      direction: 'DESC',
    });
    setFilters({
      plataforma: '',
      versao: '',
    });
    setInputSearchValue(null);
  };

  const onChangeItemFilter = (event, field) => {
    setIsLoading(true);
    event.stopPropagation();
    setFilters({ ...filters, [field]: event.target.value });
  };

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderBy,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  const handleFilterByStatus = async (status) => {
    setIsLoading(true);
    setData(null);
    if (JSON.stringify(status) === JSON.stringify(filters?.status)) {
      setFilters((f) => ({ ...f, status: null }));
      return;
    }
    setFilters((f) => ({ ...f, status: status }));
    setPaginationFilters({
      ...paginationFilters,
      page: 0,
    });
  };

  const handleStateClick = (item) => {
    const statusAction = item.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar';
    const statusMessage =
      item.status === 'APROVADO' ? 'Desaprovada' : 'Aprovada';

    handleModalAdmin({
      title: `${item.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar'} versão`,
      content: `Você tem certeza que deseja ${statusAction} essa versão?`,
      msgOnSuccess: `A versão APP foi ${statusMessage} com sucesso`,
      msgOnError: `A versão APP não foi ${statusMessage} Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: () => onConfirmChangeStatus(item),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleDeleteClick = (idVersao) => {
    handleModalAdmin({
      title: `Excluir versão`,
      content: `Você tem certeza que deseja excluir essa versão?`,
      msgOnSuccess: `Versão excluída com sucesso`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: async () => await VersaoAppService.delete(idVersao),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleEditClick = (idVersao) => {
    history.push(`/tabelas-de-controle/versao/${idVersao}/edit`);
  };

  useEffect(() => {
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, paginationFilters, inputSearchValue, statusFilter]);

  useEffect(() => {
    getFilterOptionsData();
  }, []);

  const tableColumns = [
    {
      field: 'dataCriacao',
      id: 'dataCriacao',
      label: 'Data',
      minWidth: 10,
    },
    {
      field: 'plataforma',
      id: 'plataforma',
      label: 'Loja',
      minWidth: 10,
      align: 'left',
    },
    {
      field: 'versao',
      id: 'versao',
      label: 'Versão',
      minWidth: 50,
      align: 'left',
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 150,
      align: 'left',
    },
  ];

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p style={{ color: color, fontWeight: 'bold' }}>Filtrar</p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: '12px',
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
          <AccordionDetails>
            <div className="accordionDetails-container-funcionalidades">
              <div className="content-left">
                <div className="subContent-menu">
                  <div>
                    <div className="label-style">
                      <label htmlFor="input-loja">Loja</label>
                    </div>
                    <select
                      id="input-loja"
                      value={filters?.plataforma}
                      className="correct-color"
                      onChange={(event) =>
                        onChangeItemFilter(event, 'plataforma')
                      }
                    >
                      <option value={''}>Todos</option>
                      {filterOptions?.plataforma?.map((plataforma) => (
                        <option
                          key={plataforma}
                          value={plataforma}
                          title={plataforma}
                        >
                          {plataforma}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <div className="label-style">
                      <label htmlFor="input-versao">Versão</label>
                    </div>
                    <select
                      id="input-versao"
                      value={filters?.versao}
                      className="correct-color"
                      onChange={(event) => onChangeItemFilter(event, 'versao')}
                    >
                      <option value={''}>Todos</option>
                      {filterOptions?.versao?.map((version) => (
                        <option key={version} value={version} title={version}>
                          {version}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </FilterContainer>
    );
  };

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      {renderFilters('#B3B3B3')}

      <WrapperLegend>
        <ColumnGap
          gap="7px"
          padding="6px 10px"
          backgroundColor={!!pendants && 'rgba(196, 196, 196, 0.2)'}
        >
          {!!pendants && (
            <>
              <BaSeIcon
                name="exclamation-circle"
                size={28}
                color="#ff0000"
                description={'Gerenciamento'}
              />
              <Row align="center">
                <Text color="#B3B3B3">Existem&nbsp;</Text>
                <Text color="#ff0000" weight="bold">
                  {pendants} &nbsp;
                </Text>
                <Text color="#B3B3B3">itens aguardando aprovação.</Text>
              </Row>
            </>
          )}
        </ColumnGap>

        <FlexDirectionWrapper>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            onClick={() => handleFilterByStatus(['APROVADO'])}
          >
            <FaRegCheckCircle size={25} color="#0061C6" />
            <Text
              margin="4px"
              color={
                filters?.status?.includes('APROVADO') ? 'black' : '#B3B3B3'
              }
            >
              Aprovado
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => handleFilterByStatus(['PENDENTE', 'DESAPROVADO'])}
          >
            <FaRegCheckCircle size={25} color="#FF0000" />
            <Text
              margin="4px"
              color={
                filters?.status?.includes('PENDENTE') ? 'black' : '#B3B3B3'
              }
            >
              Aguardando aprovação
            </Text>
          </div>
        </FlexDirectionWrapper>
      </WrapperLegend>

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <div>
          <p className="" style={{ color: '#0061C6' }}>
            {data?.totalElements ?? 0}{' '}
            <strong className="find-results"> resultados encontrados </strong>
          </p>
        </div>

        {!!data?.totalElements && (
          <ExcelExportAdmin
            filename={`Exportacao_Versao_APP_${formatDateToBR(new Date())}`}
            handleDataCallback={getDataExcel}
            isCsv
          />
        )}
      </FlexDirectionWrapper>

      <TableAdmin
        data={data}
        columnAction={'actions'}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleDeleteClick={handleDeleteClick}
        handleEditClick={handleEditClick}
        handleOrderClick={handleOrderClick}
        onInputPageChange={handleInputPageChange}
        handleStateClick={handleStateClick}
      />
    </MainContent>
  );
};
